module.exports = __webpack_public_path__ + "components/page-footer/static/snow-icon-background-41736d2e2b06b8f941cf38a50e33c0e8.svg";